import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import AlarmContainer from '@home/containers/AlarmContainer.vue'
@Component({
    components: { PageHeaderWithActionBar, AlarmContainer }
})
export default class AlarmView extends Vue {}
